export default __webpack_public_path__ + "static/media/password_digital_accounts.9dd948bf.pdf";